import { Props as SelectProps } from "react-select";

import { SelectComponent } from "../SelectComponent";
import { Module } from "@/@types/app/Module";
import { Option } from "@/@types/generics/Option";

type Props = SelectProps & {
	modules: Module[];
	noDefaultOption?: boolean;
};

export function ModuleSelect({ modules, noDefaultOption, ...rest }: Props) {
	const options: Option<number>[] = [
		...modules?.map((module) => ({
			value: module.id,
			label: module.description || "Todos os módulos",
		})),
	];

	return (
		<div className="d-flex flex-column">
			<label title="Lista de Módulos Disponíveis" htmlFor={rest.id} className="form-label">
				Módulo de acesso:
			</label>
			<SelectComponent
				className="fs-8 p-0"
				options={options}
				id={rest.id}
				placeholder="Selecione..."
				noOptionsMessage={() => "Nenhum módulo encontrado"}
				{...rest}
			/>
		</div>
	);
}
